import {emptyBrief, productAreas} from "./product-brief-schema";

const outputSchema = {
    requestType: "new-feature | behavior-change | ui-improvement | bugfix",
    featureName: "",
    priority: "critical | high | medium | low",
    involvedAreas: "",
    requester: "",
    requestDate: "",
    codexMode: "analysis | frontend-after-receipt | ui-only | bugfix",
    problem: "",
    targetUser: "",
    targetRole: "",
    businessImpact: "",
    existingProductRelation: "",
    userScenario: [""],
    allowedRoles: [{role: "", action: "", description: ""}],
    deniedRoles: [{role: "", limitation: "", description: ""}],
    productLocation: "",
    expectedOutcome: "",
    acceptanceCriteria: [""],
    connectedAreas: ["Goal | Project | Deliverable / Milestone | Task | Team | Calendar | Notification | File | Comment | Report | None / Unknown"],
    outOfScope: [""],
    openQuestions: [""],
    dependencies: "",
    technicalNotes: {
        backendReceiptPath: "",
        bcrPath: "",
        knownEndpointOrContract: "",
        extraNotes: "",
    },
};

export function buildProductBriefAiPrompt({description, brief, includeCurrentBrief}) {
    const lines = [
        "شما دستیار محصول زوفینو هستید و باید توضیح خام کاربر را به Product Brief ساختاریافته تبدیل کنید.",
        "",
        "قانون خروجی:",
        "فقط و فقط یک JSON معتبر برگردان. هیچ Markdown، code fence، heading یا توضیح اضافه تولید نکن.",
        "تمام keyهای schema باید وجود داشته باشند.",
        "همه مقدارهای متنی را فارسی بنویس.",
        "برای requestType فقط یکی از این مقدارها مجاز است: new-feature, behavior-change, ui-improvement, bugfix.",
        "برای priority فقط یکی از این مقدارها مجاز است: critical, high, medium, low.",
        "برای codexMode فقط یکی از این مقدارها مجاز است: analysis, frontend-after-receipt, ui-only, bugfix.",
        `برای connectedAreas فقط از این گزینه‌ها انتخاب کن: ${productAreas.join(", ")}.`,
        "userScenario حداقل 3 مرحله عملی داشته باشد.",
        "acceptanceCriteria حداقل 3 معیار قابل آزمایش داشته باشد.",
        "allowedRoles حداقل یک نقش واقعی و قابل فهم داشته باشد.",
        "deniedRoles محدودیت‌های محتمل و منطقی را پوشش دهد.",
        "outOfScope حداقل یک مورد داشته باشد.",
        "openQuestions فقط ابهام‌های واقعی را ثبت کند.",
        "endpoint، Backend Receipt، BCR، relation، permission یا contract خیالی نساز.",
        "اگر اطلاعات فنی تاییدشده وجود ندارد، backendReceiptPath، bcrPath و knownEndpointOrContract را خالی بگذار و ابهام فنی را در openQuestions ثبت کن.",
        "اگر برای یک فیلد اطلاعات کافی نیست، بهترین فرض منطقی را بنویس و فرض را در openQuestions ثبت کن.",
        "requestDate و requester را از فرم فعلی حفظ کن، مگر اینکه کاربر صریحا مقدار دیگری گفته باشد.",
        "",
        "Schema دقیق خروجی:",
        JSON.stringify(outputSchema, null, 2),
        "",
        "توضیح خام کاربر:",
        description,
    ];

    if (includeCurrentBrief) {
        lines.push(
            "",
            "زمینه فرم فعلی، فقط برای تکمیل بهتر و حفظ requester/requestDate در صورت نبود دستور خلاف:",
            JSON.stringify(brief || emptyBrief, null, 2)
        );
    }

    return lines.join("\n");
}
